<section>
	<h1><span class="text-blue-light">Path to Honor</span><span class="text-blue-dark"> Core&nbsp;Values</span></h1>
	<h2>Base Page Template</h2>
</section>
